import axios from 'axios';
import * as qs from 'qs';

export class ReportDashboardTargetApi {
  // API 1: Get employee filter options
  getEmployeeFilter = async () => {
    const path = `/api/DashBoard/EmployeeFilter`;
    const config = {
      method: 'get',
      url: path,
      headers: {
        ByPassAuth: true,
      },
    };

    try {
      if (window.isOffline) {
        return this.getMockEmployeeFilter();
      } else {
        const res = await axios(config);
        return res.data;
      }
    } catch (error) {
      return this.getMockEmployeeFilter();
    }
  };

  // API 2: Get basic dashboard info
  getBasicInfo = async () => {
    const path = `/api/DashBoard/BasicInfo`;
    const config = {
      method: 'get',
      url: path,
      headers: {
        ByPassAuth: true,
      },
    };

    try {
      if (window.isOffline) {
        return this.getMockBasicInfo();
      } else {
        const res = await axios(config);
        return res.data;
      }
    } catch (error) {
      return this.getMockBasicInfo();
    }
  };

// API 3: Get target dashboard data
getTargetData = async (params: { employeeId?: string; searchText?: string } = {}) => {
  const path = '/api/DashBoard/TargetDashboard';
  const config = {
    method: 'get',
    url: path,
    params: {
      employeeId: params.employeeId,
      searchText: params.searchText
    },
    headers: {
      ByPassAuth: true,
    },
  };

  try {
    if (window.isOffline) {
      return this.getMockTargetData();
    } else {
      const res = await axios(config);
      return res.data;
    }
  } catch (error) {
    console.error('Error fetching target dashboard data:', error);
    return this.getMockTargetData();
  }
};

  // Mock data for employee filter
  private getMockEmployeeFilter = () => {
    return {
      result: true,
      responseCode: "200",
      responseMessage: "Success",
      responseDataSource: "db",
      isCalled: false,
      data: [
        { optionText: "ทั้งหมด", optionValue: "" },
        { optionText: "ชัชพล จันทร์ศรี", optionValue: "91005731" },
        { optionText: "Tadashi Yasaki", optionValue: "11002474" },
        { optionText: "รวีรัตน์พร ศิริฉัฐพล", optionValue: "70063420" }
      ],
      error: null,
      xTotalCount: 0
    };
  };

  // Mock data for basic info
  private getMockBasicInfo = () => {
    return {
      result: true,
      responseCode: "200",
      responseMessage: "Success",
      responseDataSource: "db",
      isCalled: false,
      data: {
        currentMonth: "พฤศจิกายน 2025",
        totalShops: 150,
        totalScores: 1250,
        accumulatedTarget: 5000,
        salesTarget: {
          sales: 3500,
          target: 5000,
          percentage: 70
        },
        shortage: 1500
      },
      error: null,
      xTotalCount: 0
    };
  };

  // Mock data for target dashboard
  private getMockTargetData = () => {
    return {
      result: true,
      responseCode: '200',
      responseMessage: 'Success',
      responseDataSource: 'db',
      isCalled: false,
      data: [
        {
          group: 'A',
          customerScore: [
            {
              customerCode: 'C001',
              customerName: 'ร้านค้า เอ',
              employee: 'EMP001 - สมชาย ใจดี',
              targetScore: 1200,
              salesScore: 850,
              totalScore: 380
            },
            {
              customerCode: 'C002',
              customerName: 'ร้านค้า บี',
              employee: 'EMP002 - มานี รักดี',
              targetScore: 1100,
              salesScore: 950,
              totalScore: 320
            }
          ]
        },
        {
          group: 'B',
          customerScore: [
            {
              customerCode: 'C003',
              customerName: 'ร้านค้า ซี',
              employee: 'EMP003 - วีระ บุญมี',
              targetScore: 1300,
              salesScore: 750,
              totalScore: 350
            },
            {
              customerCode: 'C004',
              customerName: 'ร้านค้า ดี',
              employee: 'EMP004 - สมศรี เจริญ',
              targetScore: 800,
              salesScore: 450,
              totalScore: 200
            }
          ]
        }
      ],
      error: null,
      xTotalCount: 4
    };
  };
}